import { MessageCircle, X } from '../../icons/wp-icons';
import ChatWidget from './ChatWidget';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useChat } from '../../context/ChatContext';
import { useBranding } from '../../hooks/useBranding';
import { useAuth } from '../../context/AuthContext';

const HEYKIKI_ACCENT = '#81c264';

export default function FloatingChatButton() {
  const { isChatOpen: isOpen, setIsChatOpen: setIsOpen } = useChat();
  const isMobile = useIsMobile();
  const { chatIconUrl } = useBranding();
  const { user } = useAuth();
  const isHeykikiOrg = user?.organisation?.orgType === 'HEYKIKI';

  // Auf Mobile: Button verstecken wenn Chat offen (Chat hat eigenen Zurück-Button)
  const showButton = !isMobile || !isOpen;

  return (
    <>
      {/* Chat Widget - immer gemounted, nur versteckt, damit laufende Requests nicht abbrechen */}
      <ChatWidget onClose={() => setIsOpen(false)} isOpen={isOpen} />

      {/* Floating Button - auf Mobile versteckt wenn Chat offen */}
      {showButton && (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`
            fixed right-4 z-50
            w-14 h-14 rounded-full
            flex items-center justify-center
            shadow-lg transition-all duration-300 ease-in-out
            ${isOpen
              ? 'bg-gray-600 hover:bg-gray-700 rotate-90'
              : isHeykikiOrg
                ? 'bg-white heykiki-chat-btn'
                : 'bg-primary hover:bg-primary-dark hover:shadow-xl'
            }
          `}
          style={{
            bottom: isMobile
              ? 'calc(24px + var(--bottom-nav-height, 64px) + var(--safe-area-bottom, 0px) + 16px)'
              : '24px',
            ...(isHeykikiOrg && !isOpen ? {
              border: `2px solid ${HEYKIKI_ACCENT}`,
              padding: '2px'
            } : {})
          }}
          aria-label={isOpen ? 'Chat schließen' : 'Chat öffnen'}
        >
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : isHeykikiOrg ? (
            <img
              src="/heykiki-chat-logo.png"
              alt="HeyKiki Chat"
              className="w-full h-full object-contain rounded-full"
            />
          ) : chatIconUrl ? (
            <img
              src={chatIconUrl}
              alt="Chat"
              className="w-11 h-11 sm:w-10 sm:h-10 object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          ) : (
            <MessageCircle className="w-6 h-6 text-white" />
          )}
        </button>
      )}
    </>
  );
}
